import FileItem from "components/shared/fileItem";

import Loader from "components/shared/loader";
import React, { useEffect, useState } from "react";

const DisplayFiles = ({ id, source }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [files, setFiles] = useState([]);

    useEffect(() => {
        setIsLoading(true);

        (async () => {
            const response = await source.getFiles({ id });

            if (response) {
                setFiles(response);
            }

            setIsLoading(false);
        })();
    }, []);

    if (isLoading) {
        return (
            <div className="loader-wrap">
                <Loader prefix="absolute-center" />
            </div>
        );
    }

    return (
        <div className="d-flex flex-wrap gap-2">
            {files.map((file) => (
                <FileItem key={file.id} file={file} withoutRemove />
            ))}
        </div>
    );
};

export default DisplayFiles;
